export const PATH = {
  AUDIT: 'audit',
  AUDIT_FILTERS_DATA: 'audit/filtersData',
  RATES: 'rates',
}
